// components/SearchTabs.jsx
import React from "react"
import { useTranslation } from "react-i18next"
import { cn } from "../../../lib"

const TABS = [
  { key: "tour", labelKey: "filter.tours", href: "/book/filter/packages" },
  { key: "bus", labelKey: "dashboard.bus_tickets", href: "/book/filter/bus" },
  { key: "avia", labelKey: "dashboard.avia_tickets", href: "/book/filter/transport" },
  { key: "excursion", labelKey: "modules.travel_excursion", href: "/book/filter_excursion/index" },
  { key: "insurance", labelKey: "admin.insurance", href: "/book/filter_insurance/index" },
  { key: "service", labelKey: "admin.service_search", href: "/book/service/search" },
]

const SearchTabs = ({ active }) => {
  const { t } = useTranslation()

  return (
    <div className="flex flex-wrap rounded-t-lg overflow-hidden">
      {TABS.map((tab) => {
        const isActive = tab.key === active

        return (
          <a
            key={tab.key}
            href={tab.href}
            aria-current={isActive ? "page" : undefined}
            className={cn(
              "whitespace-nowrap px-6 py-4 text-sm font-semibold transition-colors",
              isActive ? "bg-white text-orange-600" : "bg-gray-100 text-gray-700 hover:bg-gray-200"
            )}
          >
            {t(tab.labelKey)}
          </a>
        )
      })}
    </div>
  )
}

export default SearchTabs
